export default __webpack_public_path__ + "static/media/desktop-character.9a1de5f3.png";